import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import { Container, Box, Typography, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, Divider, Collapse, FormControlLabel, InputLabel, Checkbox, Card } from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import config from "../../config";
import Select from "react-select";
import OrgTabs from "./OrgTabs";
import AlertBox from '../AlertBox.js';
import { startLoader, stopLoader } from "../../actions/loaderActions";
import { useDispatch } from 'react-redux';
import ConfirmDialog from '../ConfirmDialog.js';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import entityImg from '../../common/images/entity.svg';
import { useHistory } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';




const ApiBaseUrl = config.NodeApiBaseUrl;
const laravelBaseUrl = config.laravelBaseUrl;

const getDefaultHeaders = () => ({
  "x-tenant-schema": "Amplo111",
  "x-user-id": localStorage.getItem("UserId") || "",
  "x-user-email": sessionStorage.getItem("userEmail") || ""
});

const NewCompanyProfile = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const getEmptyCompanyForm = () => ({
    name: "",
    year_of_incorporation: "",
    registered_address: "",
    city: "",
    country: "",
    description: "",
    website: "",
    revenue_last_fy: "",
    num_employees: "",
    has_legal_entities: false,
    user_id: parseInt(localStorage.getItem("UserId")) || null,
    esg_framework_ids: [],
    industry_peers: [],
  });

  const getEmptyMapping = () => ({
    company_id: "",
    industry: [],
    mapping_source: "manual",
    activities: [],
    activitiesInput: "",
    level: 'company'
  });

  const esgFrameworkOptions = [
    { label: "BRSR", value: 1 },
    { label: "CDP", value: 2 },
    { label: "CDSB", value: 3 },
    { label: "CSRD", value: 4 },
    { label: "ESRS", value: 5 },
    { label: "FFBB", value: 6 },
    { label: "GRESB", value: 7 },
    { label: "GRI", value: 8 },
    { label: "ISO", value: 9 },
    { label: "ISSB", value: 10 },
    { label: "LkSG", value: 11 },
    { label: "SBTi", value: 12 },
    { label: "SASB", value: 13 },
    { label: "TCFD", value: 14 },
    { label: "TNFD", value: 15 },
    { label: "UNGC", value: 16 },
    { label: "WDI", value: 17 },
    { label: "WEF", value: 18 }
  ];

  const [isEditMode, setIsEditMode] = useState(false);
  const [editCompanyId, setEditCompanyId] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editCompany, setEditCompany] = useState(null);
  const [previewCompany, setPreviewCompany] = useState(null);
  const [industries, setIndustries] = useState([]);
  const [companyForm, setCompanyForm] = useState(getEmptyCompanyForm());
  const [openSections, setOpenSections] = useState({});
  const printRef = useRef();
  const [yearInput, setYearInput] = useState(() => {
    const yoi = companyForm.year_of_incorporation;
    if (yoi && yoi.includes('-')) {
      return new Date(yoi).getFullYear().toString();
    }
    return yoi || '';
  });
  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: '',
    content: '',
    onConfirm: () => { },
  });

  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [formInitialState, setFormInitialState] = useState(getEmptyCompanyForm());
  const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);


  const fetchCompanies = async () => {
    dispatch(startLoader());
    try {
      const res = await axios.get(`${ApiBaseUrl}getAllCompanies`, { headers: getDefaultHeaders() });
      let allCompanies = res.data.data || [];

      // Super Admin Restriction: Filter by Project Selection "Client"
      const userEmail = sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail");
      if (userEmail && userEmail.toLowerCase() === "superadmin@amplo.com") {
        try {
          const projectSelectionStr = sessionStorage.getItem("projectSelection");
          if (projectSelectionStr) {
            const projectSelection = JSON.parse(projectSelectionStr);
            if (projectSelection.client && projectSelection.client.company_id) {
              const selectedId = String(projectSelection.client.company_id);
              allCompanies = allCompanies.filter(c => String(c.company_id) === selectedId);
            }
          }
        } catch (e) {
          console.warn("Error parsing projectSelection for company filtering:", e);
        }
      }

      setCompanies(allCompanies);
      dispatch(stopLoader());
    } catch (err) {
      dispatch(stopLoader());
      console.error("Fetch failed", err);
    }
  };

  const fetchIndustries = async () => {
    try {
      const res = await axios.get(`${laravelBaseUrl}industry-collection`, { headers: getDefaultHeaders() });
      setIndustries(res.data.data || []);
    } catch (err) {
      console.error("Industry fetch failed", err);
    }
  };

  useEffect(() => {
    fetchCompanies();
    fetchIndustries();
  }, []);

  const handleAddMapping = () => {
    const mappings = Array.isArray(companyForm.industry_mappings) ? companyForm.industry_mappings : [];
    setCompanyForm({
      ...companyForm,
      industry_mappings: [...mappings, getEmptyMapping()],
    });
  };

  const handleCompanySubmit = async (e) => {
    e.preventDefault();
    dispatch(startLoader());
    try {
      // STEP 1: Submit company data
      const companyPayload = {
        ...companyForm
      };

      const url = isEditMode
        ? `${ApiBaseUrl}updateCompany/${editCompanyId}`
        : `${ApiBaseUrl}createCompany`;

      const method = isEditMode ? "put" : "post";

      const companyResponse = await axios[method](url, companyPayload, {
        headers: getDefaultHeaders()
      });

      const company_id = isEditMode
        ? editCompanyId
        : companyResponse?.data?.company_id || companyResponse?.data?.id;

      if (!company_id) {
        dispatch(stopLoader());
        showAlert('error', 'Company saved, but no company_id returned.')
        return;
      }

      // STEP 2: Loop through each industry mapping and call appropriate API
      for (const mapping of companyForm.industry_mappings || []) {
        const cleanedPeers = (mapping.industry_peers || []).map((peer) => {
          if (typeof peer === "string") {
            return { name: peer, website: "" };
          } else if (typeof peer === "object") {
            return {
              peer_id: peer.peer_id || undefined,
              name: peer.name || "",
              website: peer.website || ""
            };
          } else {
            return { name: "", website: "" };
          }
        });

        const payload = {
          company_id,
          level: "company",
          industry: mapping.industry || [],
          activities: mapping.activities || [],
          industry_peers: cleanedPeers,
          display_industry: mapping.display_industry || ""
        };

        if (mapping.record_id) {
          await axios.put(`${ApiBaseUrl}updateIndustryGroupedMetadata`, {
            record_id: mapping.record_id,
            ...payload
          }, {
            headers: getDefaultHeaders()
          });
        } else {
          await axios.post(`${ApiBaseUrl}saveIndustryGroupedMetadata`, payload, {
            headers: getDefaultHeaders()
          });
        }
      }
      fetchCompanies();
      showAlert(
        'success',
        isEditMode ? 'Your Company Profile has been successfully updated.!' : 'Your Company Profile has been successfully created.!'
      );
      setShowModal(false);
      setIsEditMode(false);
      setEditCompanyId(null);
      setCompanyForm(getEmptyCompanyForm());
      dispatch(stopLoader());
    } catch (err) {
      dispatch(stopLoader());
      console.error("❌ Error during company or mapping save:", err);
      showAlert('error', 'Error saving company or mappings.');
    }
  };

  const deleteCompany = async (companyId) => {
    try {
      setConfirmDialog({
        open: true,
        title: 'Delete Company?',
        content: 'Are you sure you want to delete this company?',
        onConfirm: async () => {
          await axios.delete(`${ApiBaseUrl}deleteCompany/${companyId}`, {
            headers: getDefaultHeaders(),
          });
          fetchCompanies();
          setConfirmDialog((prev) => ({ ...prev, open: false }));
        },
      });

    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  const openEditModal = async (company) => {
    dispatch(startLoader());
    try {
      // Fetch grouped industry mappings
      const res = await axios.get(`${ApiBaseUrl}getGroupedIndustryMetadata`, {
        headers: getDefaultHeaders(),
        params: {
          companyId: company.company_id,
          entityId: null, // or pass actual entity_id if needed
        }
      });
      const mappings = res.data?.data || [];

      setFormInitialState({
        ...company,
        industry_peers: Array.isArray(company.industry_peers)
          ? company.industry_peers.map(p => ({ name: p.name || "", website: p.website || "" }))
          : [],
        industry_mappings: mappings.map((m) => ({
          ...m,
          activitiesInput: (m.activities || []).join(", ")
        }))
      });

      setCompanyForm({
        ...company,
        industry_peers: Array.isArray(company.industry_peers)
          ? company.industry_peers.map(p => ({ name: p.name || "", website: p.website || "" }))
          : [],
        industry_mappings: mappings.map((m) => ({
          ...m,
          activities: m.activities || [],
          activitiesInput: (m.activities || []).join(", ")
        }))
      });


      const year = company.year_of_incorporation
        ? new Date(company.year_of_incorporation).getFullYear().toString()
        : '';
      setYearInput(year);

      setIsEditMode(true);
      setEditCompanyId(company.company_id);
      setShowModal(true);
      dispatch(stopLoader());
    } catch (err) {
      dispatch(stopLoader());
      console.error("❌ Error loading company mappings:", err);
      showAlert('error', 'Failed to load industry mappings for this company.');
    }
  };


  const handleDeleteMapping = (idx) => {
    const mapping = companyForm.industry_mappings[idx];
    if (mapping.record_id) {
      setConfirmDialog({
        open: true,
        title: 'Delete Mapping?',
        content: 'This mapping exists on the server. Do you want to delete it?',
        onConfirm: async () => {
          try {
            await axios.delete(`${ApiBaseUrl}deleteGroupedIndustryMetadata`, {
              headers: getDefaultHeaders(),
              data: { record_id: mapping.record_id },
            });
            showAlert('success', 'Mapping deleted from server.');
          } catch (err) {
            console.error('❌ Failed to delete mapping:', err);
            showAlert('error', 'Error deleting mapping.');
            setConfirmDialog((prev) => ({ ...prev, open: false }));
            return;
          }

          const updated = [...companyForm.industry_mappings];
          updated.splice(idx, 1);
          setCompanyForm({ ...companyForm, industry_mappings: updated });
          setConfirmDialog((prev) => ({ ...prev, open: false }));
        },
      });
    } else {
      const updated = [...companyForm.industry_mappings];
      updated.splice(idx, 1);
      setCompanyForm({ ...companyForm, industry_mappings: updated });
    }
  };


  const handleDeletePeer = (idx) => {
    const updated = [...companyForm.industry_peers];
    const peer = updated[idx];

    if (peer.peer_id) {
      setConfirmDialog({
        open: true,
        title: 'Delete Peer?',
        content: 'This peer exists on the server. Delete it?',
        onConfirm: async () => {
          try {
            await axios.delete(`${ApiBaseUrl}deleteCompanyPeer/${peer.peer_id}`, {
              headers: getDefaultHeaders(),
            });
            showAlert('success', 'Peer deleted from server.');
          } catch (err) {
            console.error('❌ Failed to delete peer:', err);
            showAlert('error', 'Error deleting peer.');
            setConfirmDialog((prev) => ({ ...prev, open: false }));
            return;
          }

          updated.splice(idx, 1);
          setCompanyForm({ ...companyForm, industry_peers: updated });
          setConfirmDialog((prev) => ({ ...prev, open: false }));
        },
      });
    } else {
      updated.splice(idx, 1);
      setCompanyForm({ ...companyForm, industry_peers: updated });
    }
  };


  const openPreviewModal = async (company) => {
    dispatch(startLoader());
    try {
      setPreviewCompany(company)
      dispatch(stopLoader());
    } catch (err) {
      dispatch(stopLoader());
      console.error("❌ Error loading industry mappings for preview:", err);
      showAlert('error', 'Failed to load full data for preview.');
    }
  };

  const showAlert = (type, msg) => {
    setAlert({ open: true, message: msg, severity: type });
  };

  const handleClose = () => setAlert(prev => ({ ...prev, open: false }));

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const sortedCompanies = [...companies].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aValue = a[sortConfig.key]?.toString().toLowerCase() || '';
    const bValue = b[sortConfig.key]?.toString().toLowerCase() || '';
    if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  const handleClick = () => {
    history.push('/new-entity');
  };

  const allPeers = [
    ...(companyForm.industry_peers || []),
    ...(companyForm.entity_peers || [])
  ];


  return (
    <>
      <DashboardHeader />
      <Box display="flex">
        <DashboardSidebar />
        <Box component="main" flexGrow={1} p={3} mt={5} >
          <Box display="flex" justifyContent="space-between" mb={3} alignItems="center">
            <Typography variant="h5">Organization Structure</Typography>
            <Box display="flex" alignItems="center">
              <img
                src={require("./../../common/images/diva-icon.png")}
                alt="Logo"
                style={{ marginRight: 8, height: 24 }}
              />
              <Typography variant="caption">Powered by Amploglobal</Typography>
            </Box>
          </Box>
          <OrgTabs />
          <Container maxWidth="lg">
            <Box mt={4} justifyContent="space-between" alignItems="center">
              <div className="card-header d-flex justify-content-between">
                <span>Company Profile</span>
                <Button variant="contained" color="primary" onClick={() => {
                  const emptyForm = getEmptyCompanyForm();
                  setCompanyForm(emptyForm);
                  setFormInitialState(emptyForm);
                  setShowModal(true);
                }}
                >
                  + Add New Company
                </Button>

              </div>
            </Box>
            <TableContainer component={Paper} sx={{ mt: 3 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sortDirection={sortConfig.key === 'name' ? sortConfig.direction : false}>
                      <TableSortLabel
                        active={true}
                        direction={sortConfig.key === 'name' ? sortConfig.direction : 'asc'}
                        onClick={() => handleSort('name')}
                        hideSortIcon={false}

                      >
                        Name
                      </TableSortLabel>
                    </TableCell>
                    <TableCell sortDirection={sortConfig.key === 'country' ? sortConfig.direction : false}>
                      <TableSortLabel
                        active={true}
                        direction={sortConfig.key === 'country' ? sortConfig.direction : 'asc'}
                        onClick={() => handleSort('country')}
                        hideSortIcon={false}

                      >
                        Country
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>Website</TableCell>
                    <TableCell>Entity Count</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedCompanies.map((c, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <Typography
                          onClick={() => openPreviewModal(c)}
                          style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                          variant="body2"
                        >
                          {c.name}
                        </Typography>
                      </TableCell>
                      <TableCell>{c.country}</TableCell>
                      <TableCell>{c.website}</TableCell>
                      <TableCell>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                          <div
                            onClick={handleClick}
                            style={{
                              cursor: 'pointer',
                              backgroundImage: `url(${entityImg})`,
                              backgroundSize: 'contain',
                              backgroundRepeat: 'no-repeat',
                              backgroundPosition: 'center',
                              width: '60px',
                              height: '36px',
                              position: 'relative',
                            }}
                          >
                            <div
                              style={{
                                position: 'absolute',
                                left: '75%',
                                transform: 'translateX(-50%)',
                                background: 'rgb(0, 115, 165)',
                                color: 'white',
                                borderRadius: '20px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                minWidth: '35px',
                                textAlign: 'center',
                                padding: '2px 0px',
                                bottom: '0px',
                              }}

                            >
                              {c.entities?.length}
                            </div>

                          </div>
                        </div>
                      </TableCell>

                      <TableCell>
                        <Tooltip title="Edit">
                          <IconButton onClick={() => openEditModal(c)}><EditIcon /></IconButton>
                        </Tooltip>
                        <Tooltip title="Preview">
                          <IconButton onClick={() => openPreviewModal(c)}><VisibilityIcon /></IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton onClick={() => deleteCompany(c.company_id)}><DeleteIcon color="error" /></IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Container>
        </Box>
      </Box>

      {/* Modal for Add/Edit Company */}
      <Dialog open={showModal} onClose={() => {
        if (isEqual(companyForm, formInitialState)) {
          setShowModal(false);
        } else {
          setConfirmDialog({
            open: true,
            title: 'Unsaved Changes',
            content: 'Changes will be lost. Do you want to exit?',
            onConfirm: () => {
              setShowModal(false);
              setConfirmDialog(prev => ({ ...prev, open: false }));
            }
          });
        }
      }} maxWidth="md" fullWidth>
        <DialogTitle>{editCompany ? "Edit Company" : "Add New Company"}</DialogTitle>
        <IconButton
          onClick={() => {
            if (isEqual(companyForm, formInitialState)) {
              setShowModal(false);
            } else {
              setConfirmDialog({
                open: true,
                title: 'Unsaved Changes',
                content: 'Changes will be lost. Do you want to exit?',
                onConfirm: () => {
                  setShowModal(false);
                  setConfirmDialog(prev => ({ ...prev, open: false }));
                }
              });
            }
          }}
          style={{
            position: 'absolute',
            right: 0,
            top: '15px',
            color: '#888',
          }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid container spacing={2}>
            {[
              'name',
              'country',
              'city',
              'registered_address',
              'website',
              'description'
            ].map((field) => (
              <Grid item xs={6} key={field}>
                <TextField
                  fullWidth
                  label={field.replace(/_/g, ' ').toUpperCase()}
                  value={companyForm[field] || ''}
                  onChange={(e) =>
                    setCompanyForm({ ...companyForm, [field]: e.target.value })
                  }
                />
              </Grid>
            ))}
            <Grid item xs={6}>
              <TextField
                fullWidth
                type="number"
                label="REVENUE LAST FY"
                value={companyForm.revenue_last_fy || ''}
                onChange={(e) =>
                  setCompanyForm({ ...companyForm, revenue_last_fy: Number(e.target.value) })
                }
              />
            </Grid>

            {/* Employees */}
            <Grid item xs={6}>
              <TextField
                fullWidth
                type="number"
                label="NO. OF EMPLOYEES"
                value={companyForm.num_employees || ''}
                onChange={(e) =>
                  setCompanyForm({ ...companyForm, num_employees: Number(e.target.value) })
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Year of Incorporation"
                type="number"
                inputProps={{ min: 1900, max: new Date().getFullYear() }}
                value={yearInput}
                onChange={(e) => {
                  const year = e.target.value;
                  setYearInput(year);
                  if (year.length === 4) {
                    setCompanyForm({
                      ...companyForm,
                      year_of_incorporation: `${year}-01-01`,
                    });
                  } else if (year === '') {
                    setCompanyForm({
                      ...companyForm,
                      year_of_incorporation: '',
                    });
                  }
                }}
              />

            </Grid>


            <Grid item xs={6}>
              <InputLabel shrink>ESG Frameworks</InputLabel>
              <Select
                isMulti
                name="esg_framework_ids"
                options={[...esgFrameworkOptions].sort((a, b) => a.label.localeCompare(b.label))}
                value={(companyForm.esg_framework_ids || [])
                  .map((id) => esgFrameworkOptions.find((opt) => opt.value === id))
                  .filter(Boolean)}
                onChange={(selected) =>
                  setCompanyForm({
                    ...companyForm,
                    esg_framework_ids: (selected || []).map((s) => s.value),
                  })
                }
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={companyForm.has_legal_entities}
                    onChange={(e) =>
                      setCompanyForm({
                        ...companyForm,
                        has_legal_entities: e.target.checked,
                      })
                    }
                    color="primary"
                  />
                }
                label="Has Legal Entities?"
              />
            </Grid>
            <Divider></Divider>
            <Grid item xs={12}>
              <Card elevation={2}>
                <Box p={3}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h6">Industry Peers</Typography>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        const updated = [...(companyForm.industry_peers || [])];
                        updated.push({ name: "", website: "" });
                        setCompanyForm({ ...companyForm, industry_peers: updated });
                      }}
                      style={{ textTransform: 'none', width: '135px' }}
                    >
                      + Add Peer
                    </Button>
                  </Box>

                  {(allPeers || []).map((peer, idx) => (
                    <Card key={idx} variant="outlined" style={{ marginBottom: 16 }}>
                      <Box p={2}>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={5}>
                            <TextField
                              label="Peer Name"
                              fullWidth
                              value={peer.name}
                              disabled={peer.level === 'entity'}
                              onChange={(e) => {
                                const updated = [...companyForm.industry_peers];
                                updated[idx].name = e.target.value;
                                setCompanyForm({ ...companyForm, industry_peers: updated });
                              }}
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <TextField
                              label="Website"
                              fullWidth
                              value={peer.website}
                              disabled={peer.level === 'entity'}
                              onChange={(e) => {
                                const updated = [...companyForm.industry_peers];
                                updated[idx].website = e.target.value;
                                setCompanyForm({ ...companyForm, industry_peers: updated });
                              }}
                            />
                          </Grid>
                          <Grid item xs={2} textAlign="end">
                            <Button
                              variant="outlined"
                              color="secondary"
                              style={{ textAlign: 'end' }}
                              onClick={() => handleDeletePeer(idx)}
                              disabled={peer.level === 'entity'}
                            >
                              Delete
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                    </Card>
                  ))}
                </Box>
              </Card>
            </Grid>
          </Grid>
          <Divider></Divider>
          <Box mt={3}>
            <Card elevation={2}>
              <Box p={3}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="h6">Industry</Typography>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleAddMapping}
                    style={{ textTransform: "none" }}
                  >
                    + Add Industry
                  </Button>
                </Box>

                {Array.isArray(companyForm.industry_mappings) &&
                  companyForm.industry_mappings.map((m, idx) => {
                    if (m.level !== 'company') return null;

                    return (
                      <Card key={idx} variant="outlined" style={{ marginBottom: 24 }}>
                        <Box p={3}>
                          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="subtitle1">Industry #{idx + 1}</Typography>
                            <Button
                              size="small"
                              variant="outlined"
                              color="secondary"
                              onClick={() => handleDeleteMapping(idx)}
                            >
                              Delete
                            </Button>
                          </Box>

                          <Box mb={2}>
                            <InputLabel>Industries</InputLabel>
                            <Select
                              name="industry"
                              options={[...industries]
                                .sort((a, b) => a.valueToShow.localeCompare(b.valueToShow))
                                .map((i) => ({
                                  label: i.valueToShow,
                                  value: i.valueToShow,
                                }))}
                              value={industries
                                .map((i) => ({ label: i.valueToShow, value: i.valueToShow }))
                                .find((opt) => opt.value === (m.industry?.[0] || "")) || null}
                              onChange={(selected) => {
                                const updated = [...companyForm.industry_mappings];
                                updated[idx].industry = selected ? [selected.value] : [];
                                setCompanyForm({ ...companyForm, industry_mappings: updated });
                              }}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 1300 }),
                                menuList: (base) => ({
                                  ...base,
                                  maxHeight: 150,
                                  overflowY: 'auto',
                                }),
                              }}
                            />
                          </Box>

                          <Box>
                            <TextField
                              label="Activities (comma separated)"
                              fullWidth
                              variant="outlined"
                              value={
                                m.activitiesInput !== undefined
                                  ? m.activitiesInput
                                  : (m.activities?.join(", ") || "")
                              }
                              onChange={(e) => {
                                const input = e.target.value;
                                const updated = [...companyForm.industry_mappings];
                                updated[idx].activitiesInput = input;
                                setCompanyForm({ ...companyForm, industry_mappings: updated });
                              }}
                              onBlur={(e) => {
                                const input = e.target.value;
                                const updated = [...companyForm.industry_mappings];
                                const parsed = input.split(",").map(a => a.trim()).filter(a => a);
                                updated[idx].activities = parsed;
                                updated[idx].activitiesInput = parsed.join(", "); // Sync the visible value
                                setCompanyForm({ ...companyForm, industry_mappings: updated });
                              }}
                            />
                          </Box>
                          <Box mt={2}>
                            <TextField
                              fullWidth
                              label="Display Industry (optional)"
                              variant="outlined"
                              value={m.display_industry || ""}
                              onChange={(e) => {
                                const updated = [...companyForm.industry_mappings];
                                updated[idx].display_industry = e.target.value;
                                setCompanyForm({ ...companyForm, industry_mappings: updated });
                              }}
                            />
                          </Box>

                        </Box>
                      </Card>
                    );
                  })}

              </Box>
            </Card>
          </Box>

        </DialogContent>

        <DialogActions>
          <Button onClick={() => {
            if (isEqual(companyForm, formInitialState)) {
              setShowModal(false);
            } else {
              setConfirmDialog({
                open: true,
                title: 'Unsaved Changes',
                content: 'Changes will be lost. Do you want to exit?',
                onConfirm: () => {
                  setShowModal(false);
                  setConfirmDialog(prev => ({ ...prev, open: false }));
                }
              });
            }
          }} color="secondary">Cancel</Button>
          <Button type="submit" variant="contained" color="primary" onClick={handleCompanySubmit}>
            {isEditMode ? "Update Company" : "Create Company"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={!!previewCompany} onClose={() => setPreviewCompany(null)} maxWidth="md" fullWidth>
        <DialogTitle style={{ backgroundColor: '#CEDBE6', color: '#fff', fontWeight: 600, marginTop: 15 }}>
          Company Preview
          <IconButton
            onClick={() => {
              setPreviewCompany(null)
            }}
            style={{
              position: 'absolute',
              right: 0,
              top: '25px',
              color: '#888',
            }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers style={{ backgroundColor: '#f5f7fa', padding: '24px 32px' }}>
          <Box ref={printRef}>
            {/* COMPANY DETAILS */}
            <Card elevation={2} style={{ borderRadius: 12, marginBottom: 32, padding: 24 }}>
              <Typography variant="h5" style={{ fontWeight: 600, marginBottom: 16 }}>
                {previewCompany?.name || '-'}
              </Typography>
              <Grid container spacing={3}>
                {[{ label: 'Website', value: previewCompany?.website }, { label: 'City', value: previewCompany?.city }, { label: 'Country', value: previewCompany?.country }, { label: 'Revenue', value: previewCompany?.revenue_last_fy }, { label: 'No. of Employees', value: previewCompany?.num_employees },
                {
                  label: 'Year of Incorporation',
                  value: previewCompany?.year_of_incorporation
                    ? new Date(previewCompany.year_of_incorporation).getFullYear()
                    : null,
                }].map((field, idx) => (
                  <Grid item xs={6} key={idx}>
                    <Typography variant="subtitle2" color="textSecondary">{field.label}</Typography>
                    <Typography>{field.value || '-'}</Typography>
                  </Grid>
                ))}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="textSecondary">Description</Typography>
                  <Typography>{previewCompany?.description || '-'}</Typography>
                </Grid>
              </Grid>
            </Card>
            {/* COMPANY-LEVEL INDUSTRY PEERS */}
            {Array.isArray(previewCompany?.industry_peers) && previewCompany.industry_peers.length > 0 && (
              <Box>
                <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 12 }}>Industry Peers</Typography>
                <Card elevation={1} variant="outlined" style={{ borderRadius: 12, marginBottom: 32, padding: 24 }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" color="textSecondary" gutterBottom>Peer</Typography>
                      <Box display="flex" flexDirection="column">
                        {previewCompany.industry_peers.map(function (peer, idx) {
                          return (
                            <Box
                              key={idx}
                              style={{
                                padding: '6px 14px',
                                marginBottom: 8,
                                backgroundColor: '#e3f2fd',
                                borderRadius: 20,
                                fontSize: 14,
                                alignSelf: 'flex-start',
                                display: 'inline-block'
                              }}
                            >
                              {peer.name}
                            </Box>
                          );
                        })}
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" color="textSecondary" gutterBottom>Website</Typography>
                      <Box display="flex" flexDirection="column">
                        {previewCompany.industry_peers.map(function (peer, idx) {
                          return (
                            <Box
                              key={idx}
                              style={{
                                padding: '6px 14px',
                                marginBottom: 8,
                                backgroundColor: '#fff3e0',
                                borderRadius: 20,
                                fontSize: 14,
                                alignSelf: 'flex-start',
                                display: 'inline-block'
                              }}
                            >
                              {peer.website ? (
                                <a
                                  href={peer.website}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ textDecoration: 'none', color: '#3f51b5' }}
                                >
                                  {peer.website}
                                </a>
                              ) : (
                                '-'
                              )}
                            </Box>
                          );
                        })}
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </Box>
            )}

            {/* COMPANY-LEVEL INDUSTRY MAPPINGS */}
            {Array.isArray(previewCompany?.company_level_industry_mappings) &&
              previewCompany.company_level_industry_mappings.length > 0 && (
                <Box>
                  <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 12 }}>Industry</Typography>
                  <Card elevation={1} variant="outlined" style={{ borderRadius: 12, marginBottom: 24, padding: 24 }}>
                    <Box display="flex" flexWrap="wrap">
                      {[...new Set(
                        previewCompany.company_level_industry_mappings
                          .flatMap((m) => m.industry || [])
                          .map((ind) => (typeof ind === 'object' ? ind.industry_name : ind))
                      )]
                        .sort((a, b) => a.localeCompare(b))
                        .map((name, idx) => (
                          <Box
                            key={idx}
                            style={{
                              padding: '6px 14px',
                              marginRight: 8,
                              marginBottom: 8,
                              backgroundColor: '#e3f2fd',
                              borderRadius: 20,
                              fontSize: 14,
                            }}
                          >
                            {name}
                          </Box>
                        ))}
                    </Box>
                  </Card>
                </Box>
              )}

            {/* LEGAL ENTITIES */}
            {Array.isArray(previewCompany?.entities) && previewCompany.entities.length > 0 && (
              <Box>
                <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 12 }}>
                  Legal Entities
                </Typography>
                <Card elevation={1} variant="outlined" style={{ borderRadius: 12, marginBottom: 32, padding: 24 }}>
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {previewCompany.entities.map((entity, idx) => (
                      <Typography
                        key={idx}
                        style={{
                          padding: '6px 14px',
                          backgroundColor: '#fce4ec',
                          borderRadius: 20,
                          display: 'inline-block',
                          margin: 8,
                        }}
                      >
                        {entity.name || '-'}
                      </Typography>
                    ))}
                  </Box>
                </Card>
              </Box>
            )}

            {/* OPERATING UNITS */}
            {Array.isArray(previewCompany?.company_level_operating_units) && previewCompany.company_level_operating_units.length > 0 ? (
              <Box>
                <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 12 }}>Operating Units</Typography>

                {previewCompany.company_level_operating_units.map((unit, idx) => (
                  <Card key={idx} elevation={1} variant="outlined" style={{ borderRadius: 12, marginBottom: 24, padding: 24 }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>{unit.name}</Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary">Products</Typography>
                        <Box display="flex" flexWrap="wrap">
                          {(unit.products || []).map((prod, i) => (
                            <Box key={i} style={{ padding: '6px 14px', marginRight: 8, marginBottom: 8, backgroundColor: '#e8f5e9', borderRadius: 20, fontSize: 14 }}>
                              {prod}
                            </Box>
                          ))}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary">Services</Typography>
                        <Box display="flex" flexWrap="wrap">
                          {(unit.services || []).map((srv, i) => (
                            <Box key={i} style={{ padding: '6px 14px', marginRight: 8, marginBottom: 8, backgroundColor: '#ede7f6', borderRadius: 20, fontSize: 14 }}>
                              {srv}
                            </Box>
                          ))}
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                ))}
              </Box>
            ) : null}


          </Box>
        </DialogContent>

        <DialogActions style={{ padding: '12px 24px' }}>
          <Button onClick={() => setPreviewCompany(null)} variant="outlined" color="primary">Close</Button>
        </DialogActions>
      </Dialog>

      <AlertBox
        open={alert.open}
        onClose={handleClose}
        message={alert.message}
        severity={alert.severity}
      />
      <ConfirmDialog
        open={confirmDialog.open}
        title={confirmDialog.title}
        content={confirmDialog.content}
        onCancel={() => setConfirmDialog({ ...confirmDialog, open: false })}
        onConfirm={confirmDialog.onConfirm}
      />

    </>
  );
};

export default NewCompanyProfile;
